/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {filterUrlLessTargeting} from '../../components/util/targeting-request';

export function transformCreativeRequest(model: any): any {
  const payload = _.cloneDeep(model);
  filterUrlLessTargeting(payload);
  if (!_.get(payload, ['lineItem', 'id'])) {
    delete payload.lineItem;
  }
  if (!_.get(payload, ['creativeSet', 'id'])) {
    delete payload.creativeSet;
  }
  return payload;
}
